export default __webpack_public_path__ + "static/media/approval_delegation.d26b3bb3.svg";